import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ReisekostenabrechnungenServiceModule } from '..';
import { ReisekostenabrechnungenSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ReisekostenabrechnungenServiceModule
  ],
  declarations: [ReisekostenabrechnungenSorterComponent],
  exports: [ReisekostenabrechnungenSorterComponent],

})
export class ReisekostenabrechnungenSorterComponentModule { }
